export default "__VITE_ASSET__CCwG3wL3__"